// extracted by mini-css-extract-plugin
export default {"button":"Tk-z","reviewSort":"Uk-z"};